
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reklama-v-fitnes-klubah",
      function () {
        return require("private-next-pages/reklama-v-fitnes-klubah/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reklama-v-fitnes-klubah"])
      });
    }
  